import React from 'react';
import {
  DesktopDatePickerProps,
  LocalizationProvider,
  DesktopDatePicker as NativeDesktopDatePicker,
} from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { pt } from 'date-fns/locale';
import { styled, TextFieldProps } from '@mui/material';
import './index.css';

const CustomNativeDesktopDatePicker = styled(NativeDesktopDatePicker)({
  '& button': {
    padding: 0,
  },
  '& input': {
    paddingRight: '0px !important',
  },
});

interface KeyboardDatePickerProps extends Omit<DesktopDatePickerProps, 'value' | 'onChange' | 'label'> {
  value: Date | null;
  onChange(date: Date | null): void;
  label?: string;
  margin?: 'none' | 'normal';
  textFieldProps?: TextFieldProps;
  // repassado ao seletor pelos formulários; o campo já ocupa a largura toda
  fullWidth?: boolean;
}

const KeyboardDatePicker: React.FC<KeyboardDatePickerProps> = ({
  value,
  onChange,
  label,
  margin = 'none',
  textFieldProps,
  slotProps,
  ...rest
}) => {
  return (
    <LocalizationProvider adapterLocale={pt} dateAdapter={AdapterDateFns}>
      <CustomNativeDesktopDatePicker
        slotProps={{ ...slotProps, textField: textFieldProps }}
        openTo="day"
        label={label}
        value={value}
        sx={{
          '& .MuiInputBase-root': {
            padding: '0px !important',
          },
          margin: margin === 'none' ? '0px!important' : '16px 0px 8px 0px!important',
          width: '100%',
        }}
        onChange={onChange}
        {...rest}
      />
    </LocalizationProvider>
  );
};

export default KeyboardDatePicker;
